import { render, staticRenderFns } from "./ChuckNorris.vue?vue&type=template&id=4ce4060a&scoped=true"
import script from "./ChuckNorris.vue?vue&type=script&lang=js"
export * from "./ChuckNorris.vue?vue&type=script&lang=js"
import style0 from "./ChuckNorris.vue?vue&type=style&index=0&id=4ce4060a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4060a",
  null
  
)

export default component.exports